const strize = require('../strize')

module.exports = {
  title: 'PP ADMIN',
  imgs: {
    root: '../../imagesPP'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: true
  },
  bucket: {
    player: {
      bucket: strize(''),
      region: strize('')
    },
    editor: {
      bucket: strize(''),
      region: strize(''),
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#000000',
    bgSideBar: '#024179',
    ActionMail:'#dadada'
  },
  layouts: {
    agencyCreate: {
      logo: false
    }
  }
}
